// extracted by mini-css-extract-plugin
module.exports = {"accordion-container":"AccordionComponent_accordion-container__6K_fu"};